// Open the cart popup
function openCartPopup() {
  document.getElementById("cart-popup").style.display = "flex";
}

// Close the cart popup
function closeCartPopup() {
  document.getElementById("cart-popup").style.display = "none";
}

// Add event listeners
document.getElementById("close-cart-popup").addEventListener("click", closeCartPopup);

// Update cart items in the popup
function updateCartItems() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartItemsContainer = document.getElementById("cart-items");
      cartItemsContainer.innerHTML = ""; // Clear current items

      cart.items.forEach(item => {
        const itemElement = document.createElement("div");
        itemElement.classList.add("cart-item");
        itemElement.innerHTML = `
          <p><strong>${item.quantity} x ${item.product_title}</strong></p>
          <p>${item.variant_title}</p>
          <p>${item.price / 100} ${cart.currency}</p>
        `;
        cartItemsContainer.appendChild(itemElement);
      });
    });
}

// Open the cart popup when the cart icon is clicked
document.querySelector('.cart-icon').addEventListener('click', function() {
  updateCartItems();
  openCartPopup();
});
